export default __webpack_public_path__ + "static/platforms-219030271a45d810abe3b674b7478f77.png";